import { DEFAULT_USER_PERMISSIONS, USER_PERMISSIONS } from "./constants";

export const getPermissions = (userProfile) => {
  const { permissions = DEFAULT_USER_PERMISSIONS } = userProfile || {};

  const hasInviteMemberPermission = permissions.create.includes(
    USER_PERMISSIONS.CREATE.INVITE_MEMBERS
  );

  const hasPermissionToViewStatsHub = permissions.view.includes(
    USER_PERMISSIONS.VIEW.STATISTICS_HUB
  );

  const hasPermissionToInteractWithApplicants = permissions.view.includes(
    USER_PERMISSIONS.VIEW.APPLICANT_HUB
  );

  const hasPermissionToManageMembers = permissions.update.includes(
    USER_PERMISSIONS.UPDATE.MANAGE_MEMBERS
  );

  const hasPermissionToUpdateBillingAddress = permissions.update.includes(
    USER_PERMISSIONS.UPDATE.BILLING_ADDRESS
  );

  const hasPermissionToViewDashboard = permissions.view.includes(USER_PERMISSIONS.VIEW.DASHBOARD);

  const hasPermissionsToRenderBudget = permissions.view.includes(USER_PERMISSIONS.VIEW.BUDGET);

  const hasPermissionsToReadCampaign = permissions.view.includes(USER_PERMISSIONS.VIEW.CAMPAIGNS);

  const hasPermissionsToRenderDraft = permissions.delete.includes(USER_PERMISSIONS.DELETE.DRAFT);

  const hasPermissionsToRenderDashboard = permissions.view.includes(
    USER_PERMISSIONS.VIEW.DASHBOARD
  );

  const hasPermissionsToRenderStatsHub = permissions.view.includes(
    USER_PERMISSIONS.VIEW.STATISTICS_HUB
  );

  const hasPermissionsToCreateCampaigns = permissions.create.includes(
    USER_PERMISSIONS.CREATE.CAMPAIGNS
  );

  const hasPermissionsToViewBudget = permissions.view.includes(USER_PERMISSIONS.VIEW.BUDGET);

  return {
    hasInviteMemberPermission,
    hasPermissionToViewStatsHub,
    hasPermissionToInteractWithApplicants,
    hasPermissionToManageMembers,
    hasPermissionToUpdateBillingAddress,
    hasPermissionToViewDashboard,
    hasPermissionsToRenderBudget,
    hasPermissionsToReadCampaign,
    hasPermissionsToRenderDraft,
    hasPermissionsToRenderDashboard,
    hasPermissionsToRenderStatsHub,
    hasPermissionsToCreateCampaigns,
    hasPermissionsToViewBudget
  };
};
